import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import css from './index.scss';

const HeaderFormatter = ({ column, onSort }) => (
    <div className={css.component} onClick={() => onSort(column.key)} role="button" tabIndex="0">
        <div className={css.title}>{column.name}</div>
        <div className={css.sort} />
    </div>
);

HeaderFormatter.propTypes = {
    column: PropTypes.object,
    onSort: PropTypes.func
};

export default HeaderFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/header-formatter/index.js